export default ":host ::ng-deep .filter>.dx-editor-filled{margin:0 !important}";